import { AssistantAdapter, HostAdapter } from "../types";
import { readCheckOutIdentity, writeCheckOutIdentity } from "./identity";
import { getDocumentAsDocx, describeSaveUnavailable, DOCX_MIME_TYPE } from "./bytes";
import { wordCloser } from "./close";
import { extractStructuredDocument, acceptEdit, rejectEdit } from "./documentTools";
import { wordToolSchemas, wordSystemPrompt } from "./toolSchemas";
import { executeToolCall } from "./toolExecutor";
import { buildEditInfo } from "./editTracker";
import { enrichCitations, reveal, WORD_SEGMENT_ID_PATTERN } from "./citations";
import { DocumentModel } from "../../features/draft/types/document";

// Word: the host this add-in was built for, and the only one with a revisions model
// (so the only one where accept / reject on an individual edit is real) and content
// controls (so the only one that can carry the Assembly reference builder).

const wordAssistant: AssistantAdapter = {
  extractDocumentModel: extractStructuredDocument,
  toolSchemas: wordToolSchemas,
  systemPrompt: wordSystemPrompt,
  executeToolCall,
  describeEdit: (toolName, rawArgs, result, docModel) =>
    buildEditInfo(toolName, rawArgs, result, docModel as DocumentModel),
  review: { acceptEdit, rejectEdit },
  suggestedPrompts: [
    "Summarise this document in five bullet points",
    "Find the termination and liability clauses",
    "Check that defined terms are used consistently",
    "Tighten the wording of the first section",
  ],
  segmentIdPattern: WORD_SEGMENT_ID_PATTERN,
  enrichCitations: (citations, docModel) => enrichCitations(citations, docModel as DocumentModel),
  reveal,
};

export const wordAdapter: HostAdapter = {
  kind: "word",
  displayName: "Word",
  capabilities: {
    assembly: true,
  },

  manifestFileName: "manifest.xml",

  documents: {
    fileExtension: "docx",
    mimeType: DOCX_MIME_TYPE,
    readCheckOutIdentity,
    writeCheckOutIdentity,
    getDocumentBytes: getDocumentAsDocx,
    describeSaveUnavailable,
    closer: wordCloser,
  },

  assistant: wordAssistant,
};
